import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './DeveloperPortalLayout.css';

interface DeveloperPortalLayoutProps {
  children: React.ReactNode;
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const DeveloperPortalLayout: React.FC<DeveloperPortalLayoutProps> = ({ 
  children, 
  activeSection, 
  onSectionChange 
}) => {
  const { user, logout } = useAuth();

        const portalItems = [
          { id: 'dashboard', label: 'Dashboard', icon: null },
          { id: 'venues', label: 'Venues/Locations', icon: null },
          { id: 'data-explorer', label: 'Data Explorer', icon: null },
          { id: 'charts', label: 'Charts & Widgets', icon: null }
        ];

  const developerItems = [
    { id: 'applications', label: 'My Applications', icon: null },
    { id: 'venue-mappings', label: 'Venue ID Mappings', icon: null },
    { id: 'test', label: 'Test Flow', icon: null },
    { id: 'docs', label: 'Documentation', icon: null }
  ];

  const settingsItems = [
    { id: 'settings', label: 'Settings', icon: null }
  ];

  return (
    <div className="developer-portal-layout">
      {/* Header */}
      <div className="portal-header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-logo">
              <img src="/PlatefullAILogo.svg" alt="PlatefullAI Logo" className="logo-image" />
            </div>
          </div>
          <div className="header-right">
            <div className="user-info">
              <span className="user-email">{user?.email}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="main-layout">
        {/* Sidebar */}
        <div className="sidebar">
          <div className="sidebar-header">
            <div className="user-card">
              <div className="user-avatar">
                {user?.email?.charAt(0).toUpperCase()}
              </div>
              <div className="user-details">
                <div className="user-name">{user?.name || 'Business User'}</div>
                <div className="user-email">{user?.email}</div>
                <div className="dev-badge">Business Account</div>
              </div>
            </div>
          </div>

          <nav className="sidebar-nav">
            <div className="nav-section">
              <div className="nav-section-title">PORTAL</div>
              {portalItems.map((item) => (
                <button
                  key={item.id}
                  className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => onSectionChange(item.id)}
                >
                  <span className="nav-label">{item.label}</span>
                </button>
              ))}
            </div>
            
            <div className="nav-section">
              <div className="nav-section-title">DEVELOPERS</div>
              {developerItems.map((item) => (
                <button
                  key={item.id}
                  className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => onSectionChange(item.id)}
                >
                  <span className="nav-label">{item.label}</span>
                </button>
              ))}
            </div>
            
            <div className="nav-section">
              <div className="nav-section-title">SETTINGS</div>
              {settingsItems.map((item) => (
                <button
                  key={item.id}
                  className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => onSectionChange(item.id)}
                >
                  <span className="nav-label">{item.label}</span>
                </button>
              ))}
            </div>
          </nav>
        </div>

        {/* Main Content */}
        <div className="content-area">
          <div className="content-view">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeveloperPortalLayout;
